export const BareRoutes = {
  EngagementReport: "/engagement-report",
  FullIntelligenceReport: "/intelligence-reports/:reportId/full",
  ReportRedirectBySn: "/reports/:deviceSN",
} as const
